import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/Auth/PrivateRoute';
import LoginForm from './components/Auth/LoginForm';
import Register from './pages/Register';
import ChangePassword from './pages/ChangePassword';
import Profile from './pages/Profile';
import Layout from './components/Layout/Layout';
import UserList from './pages/Users/UserList';
import UserForm from './pages/Users/UserForm';
import Dashboard from './pages/Dashboard/Dashboard';
import ClientList from './pages/Clients/ClientList';
import ClientForm from './pages/Clients/ClientForm';
import ClientDetail from './pages/Clients/ClientDetail';
import CatalogList from './pages/Catalog/CatalogList';
import ServiceForm from './pages/Catalog/ServiceForm';
import ServiceDetail from './pages/Catalog/ServiceDetail';
import CategoryManager from './pages/Catalog/CategoryManager';
import ProposalsList from './pages/Proposals/ProposalsList';
import ProposalFormSimple from './pages/Proposals/ProposalFormSimple';
import ProposalDetail from './pages/Proposals/ProposalDetail';
import NegotiateProposal from './pages/Proposals/NegotiateProposal';
import TestSimples from './pages/TestSimples';
import SystemSettings from './pages/Settings/SystemSettings';
import ApiManagement from './pages/Settings/ApiManagement';
import WarehouseList from './pages/Warehouses/WarehouseList';
import WarehouseForm from './pages/Warehouses/WarehouseForm';
import HolidayList from './pages/Holidays/HolidayList';
import DashboardFinanceiro from './pages/Financeiro/Dashboard/DashboardFinanceiro';
import LancamentosList from './pages/Financeiro/Lancamentos/LancamentosList';
import LancamentoForm from './pages/Financeiro/Lancamentos/LancamentoForm';
import ContasList from './pages/Financeiro/Contas/ContasList';
import ContaBancariaForm from './pages/Financeiro/Contas/ContaBancariaForm';
import CategoriasList from './pages/Financeiro/Categorias/CategoriasList';
import CategoriaForm from './pages/Financeiro/Categorias/CategoriaForm';
import BeneficiariosList from './pages/Financeiro/Beneficiarios/BeneficiariosList';
import { ContasPagarList } from './pages/Financeiro/ContasPagar/ContasPagarList';
import { ContaPagarForm } from './pages/Financeiro/ContasPagar/ContaPagarForm';
import { ContasReceberList } from './pages/Financeiro/ContasReceber/ContasReceberList';
import { ContaReceberForm } from './pages/Financeiro/ContasReceber/ContaReceberForm';
import { FaturasList } from './pages/Financeiro/Faturas/FaturasList';
import { FaturaForm } from './pages/Financeiro/Faturas/FaturaForm';
import FluxoCaixa from './pages/Financeiro/Relatorios/FluxoCaixa';
import DRE from './pages/Financeiro/Relatorios/DRE';
import MovimentacoesReport from './pages/Financeiro/Relatorios/MovimentacoesReport';
import DashboardEstoque from './pages/Estoque/Dashboard';
import MaterialList from './pages/Estoque/MaterialList';
import MaterialForm from './pages/Estoque/MaterialForm';
import MovimentacaoList from './pages/Estoque/MovimentacaoList';
import MovimentacaoForm from './pages/Estoque/MovimentacaoForm';
import NotaFiscalList from './pages/Estoque/NotaFiscalList';
import NotaFiscalDetail from './pages/Estoque/NotaFiscalDetail';
import NotaFiscalConferencia from './pages/Estoque/NotaFiscalConferencia';
import SupplierList from './pages/Financeiro/Fornecedores/SupplierList';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginForm />} />
          <Route path="/register" element={<Register />} />
          
          {/* Private routes */}
          <Route
            path="/*"
            element={
              <PrivateRoute>
                <Layout />
              </PrivateRoute>
            }
          >
            {/* Nested routes within Layout */}
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            
            {/* Client routes */}
            <Route path="clients" element={<ClientList />} />
            <Route path="clients/new" element={<ClientForm mode="create" defaultClientType="customer" returnTo="/clients" />} />
            <Route path="clients/:id" element={<ClientDetail />} />
            <Route path="clients/:id/edit" element={<ClientForm mode="edit" returnTo="/clients" />} />
            <Route path="catalog" element={<CatalogList />} />
            <Route path="catalog/services/new" element={<ServiceForm mode="create" />} />
            <Route path="catalog/services/:id" element={<ServiceDetail />} />
            <Route path="catalog/services/:id/edit" element={<ServiceForm mode="edit" />} />
            <Route path="catalog/categories" element={<CategoryManager />} />
            <Route path="proposals" element={<ProposalsList />} />
            <Route path="test-simples" element={<TestSimples />} />
            <Route path="proposals/new" element={<ProposalFormSimple />} />
            <Route path="proposals/negotiate" element={<NegotiateProposal />} />
            <Route path="proposals/:id" element={<ProposalDetail />} />
            <Route path="warehouses" element={<WarehouseList />} />
            <Route path="warehouses/new" element={<WarehouseForm mode="create" />} />
            <Route path="warehouses/edit/:id" element={<WarehouseForm mode="edit" />} />
            <Route path="holidays" element={<HolidayList />} />

            {/* Financeiro routes */}
            <Route path="financeiro/dashboard" element={<DashboardFinanceiro />} />
            <Route path="financeiro/lancamentos" element={<LancamentosList />} />
            <Route path="financeiro/lancamentos/new" element={<LancamentoForm mode="create" />} />
            <Route path="financeiro/lancamentos/:id/edit" element={<LancamentoForm mode="edit" />} />
            <Route path="financeiro/contas" element={<ContasList />} />
            <Route path="financeiro/contas/new" element={<ContaBancariaForm mode="create" />} />
            <Route path="financeiro/contas/:id/edit" element={<ContaBancariaForm mode="edit" />} />
            <Route path="financeiro/categorias" element={<CategoriasList />} />
            <Route path="financeiro/categorias/new" element={<CategoriaForm mode="create" />} />
            <Route path="financeiro/categorias/:id/edit" element={<CategoriaForm mode="edit" />} />
            <Route path="financeiro/beneficiarios" element={<BeneficiariosList />} />
            <Route path="financeiro/beneficiarios/new" element={<ClientForm mode="create" defaultClientType="both" returnTo="/financeiro/beneficiarios" />} />
            <Route path="financeiro/beneficiarios/:id/edit" element={<ClientForm mode="edit" returnTo="/financeiro/beneficiarios" />} />
            <Route path="financeiro/contas-pagar" element={<ContasPagarList />} />
            <Route path="financeiro/contas-pagar/nova" element={<ContaPagarForm />} />
            <Route path="financeiro/contas-pagar/novo" element={<ContaPagarForm />} />
            <Route path="financeiro/contas-pagar/:id" element={<ContaPagarForm />} />
            <Route path="financeiro/fornecedores" element={<SupplierList />} />
            <Route path="financeiro/fornecedores/novo" element={<ClientForm mode="create" defaultClientType="supplier" returnTo="/financeiro/fornecedores" />} />
            <Route path="financeiro/fornecedores/:id/editar" element={<ClientForm mode="edit" returnTo="/financeiro/fornecedores" />} />
            <Route path="financeiro/contas-receber" element={<ContasReceberList />} />
            <Route path="financeiro/contas-receber/novo" element={<ContaReceberForm mode="create" />} />
            <Route path="financeiro/contas-receber/:id" element={<ContaReceberForm mode="edit" />} />
            <Route path="financeiro/contas-receber/:id/editar" element={<ContaReceberForm mode="edit" />} />
            <Route path="financeiro/faturas" element={<FaturasList />} />
            <Route path="financeiro/faturas/novo" element={<FaturaForm mode="create" />} />
            <Route path="financeiro/faturas/:id/editar" element={<FaturaForm mode="edit" />} />
            <Route path="financeiro/relatorios/movimentacoes" element={<MovimentacoesReport />} />
            <Route path="financeiro/relatorios/fluxo-caixa" element={<FluxoCaixa />} />
            <Route path="financeiro/relatorios/dre" element={<DRE />} />

            {/* Estoque routes */}
            <Route path="estoque/dashboard" element={<DashboardEstoque />} />
            <Route path="estoque/materiais" element={<MaterialList />} />
            <Route path="estoque/materiais/novo" element={<MaterialForm mode="create" />} />
            <Route path="estoque/materiais/editar/:id" element={<MaterialForm mode="edit" />} />
            <Route path="estoque/movimentacoes" element={<MovimentacaoList />} />
            <Route path="estoque/movimentacoes/nova" element={<MovimentacaoForm />} />
            <Route path="estoque/notas-fiscais" element={<NotaFiscalList />} />
            <Route path="estoque/notas-fiscais/:id" element={<NotaFiscalDetail />} />
            <Route path="estoque/notas-fiscais/:id/conferir" element={<NotaFiscalConferencia />} />

            <Route path="contracts" element={<div className="p-6">Contracts Page (Coming Soon)</div>} />
            <Route path="reports" element={<div className="p-6">Reports Page (Coming Soon)</div>} />
            <Route path="users" element={<UserList />} />
            <Route path="users/new" element={<UserForm mode="create" />} />
            <Route path="users/:id/edit" element={<UserForm mode="edit" />} />
            <Route path="profile" element={<Profile />} />
            <Route path="change-password" element={<ChangePassword />} />
            <Route path="settings" element={<SystemSettings />} />
            <Route path="settings/apis" element={<ApiManagement />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;